import React, { useEffect, useState } from "react";
import CustomCard from "../../../../components/d-reusable/CustomCard";
import CustomDrawer from "../../../../components/d-reusable/CustomDrawer";
import { Col, Row, Table } from "antd";
import {
  dummyCaseAllRecordsData,
  dummyProjectsData,
  dummySingleCaseResultsData,
  mapMatchStatus,
} from "../../../../d-helper";
import {
  dentalBasePath,
  errorRequestHandel,
  formateDateAndTime,
  getProjectCode,
} from "../../../../../helper";
import { dentalIcons } from "../../../../utils-icons/dentalIcons";
import { useNavigate, useParams } from "react-router-dom";
import { getCaseSimulationsByCaseId } from "../../../../../components/https/projects-apis";
import CustomSpinner from "../../../../components/d-reusable/CustomSpiner";
// import CaseResultDetailDrawerContent from "./child/CaseResultDetailDrawerContent";

const SingleCaseAllRecords = () => {
  const { id } = useParams(); // Extract the `id` from the URL

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [details, setDetails] = useState(null);
  const [pmCase, setPmCase] = useState("");
  const [bestMatch, setBestMatch] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    getCaseSimulations();
  }, []);

  const getCaseSimulations = async () => {
    try {
      setLoading(true);
      const response = await getCaseSimulationsByCaseId({ id: id });
      if (response.status === 200) {
        const result = response.data.data;
        const bestMatchObject = result?.find((el) => el.is_best_match === true);

        if (bestMatchObject) {
          setBestMatch(bestMatchObject);
        }
        setData(result);
        setDetails(response.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  return (
    <div className="d-single_case_results_container">
      <CustomSpinner loading={loading} />
      <CustomCard>
        <div className="single_case_results_body">
          <h6>
            Match analysis for PM Case
            <span style={{ color: "#FB5858", margin: "0 5px" }}>
              {bestMatch?.pm_case?.case_number}
            </span>
            and all possible AM cases.
          </h6>
          <br />

          <Row gutter={[20, 20]}>
            <Col>
              <div className="single_case_result_information">
                <p className="_case_key">Project Code</p>
                <p className="_case_value">
                  {getProjectCode(data[0]?.project?.id)}
                </p>
              </div>
            </Col>
            <Col>
              <div className="single_case_result_information">
                <p className="_case_key">Date Created</p>
                <p className="_case_value">
                  {formateDateAndTime(details?.project_created_at)}
                </p>
              </div>
            </Col>
          </Row>

          <br />
          <Table
            // dataSource={data}
            dataSource={[...(data || [])].sort((a, b) => b.score - a.score)}
            columns={[
              {
                title: "PM Case",
                // dataIndex: "pmCase",
                key: "pmCase",
                render: (text, record) => {
                  return (
                    <div className="custom_table_row_data">
                      <p className="_title">
                        {record.pm_case?.temporary_identifier}
                      </p>
                    </div>
                  );
                },
              },
              {
                title: "AM Case",
                key: "amCase",
                render: (text, record) => {
                  return (
                    <div className="custom_table_row_data">
                      <p className="_title">{record.am_case?.full_name}</p>
                    </div>
                  );
                },
              },
              {
                title: <div className="custom_header_col">Score</div>,
                // dataIndex: "score",
                key: "score",
                onCell: (_, rowIndex) => ({
                  className: `column-${1}`,
                }),
                onHeaderCell: () => ({
                  className: `column-${1}`,
                }),
                render: (text, record) => (
                  <div className="center_align_digits">{record?.score}</div>
                ),
              },
              {
                title: <div className="custom_header_col">Matches</div>,
                key: "match_count",
                onCell: (_, rowIndex) => ({
                  className: `column-${2}`,
                }),
                onHeaderCell: () => ({
                  className: `column-${2}`,
                }),
                render: (text, record, index) => (
                  <div className="center_align_digits">
                    {record?.match_count}
                  </div>
                ),
              },
              {
                title: (
                  <div className="custom_header_col">Possible Matches</div>
                ),
                onCell: (_, rowIndex) => ({
                  className: `column-${3}`,
                }),
                onHeaderCell: () => ({
                  className: `column-${3}`,
                }),
                key: "possible_match_count",
                render: (text, record, index) => (
                  <div className="center_align_digits">
                    {record?.possible_match_count}
                  </div>
                ),
              },
              {
                title: <div className="custom_header_col">Mismatches</div>,
                key: "mismatch_count",
                onCell: (_, rowIndex) => ({
                  className: `column-${4}`,
                }),
                onHeaderCell: () => ({
                  className: `column-${4}`,
                }),
                render: (text, record, index) => (
                  <div className="center_align_digits">
                    {record?.mismatch_count}
                  </div>
                ),
              },

              {
                title: (
                  <div className="custom_header_col">Record Comparison</div>
                ),
                dataIndex: "action",
                key: "action",
                render: (text, record) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        fontSize: 12,
                        color: "#20C3FF",
                      }}
                    >
                      <div
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() =>
                          navigate(
                            `${dentalBasePath}/projects/details/case/results/${record?.id}`
                          )
                        }
                      >
                        <img
                          src={dentalIcons.viewIcon}
                          alt="Share"
                          style={{ cursor: "pointer", paddingRight: 4 }}
                        />
                      </div>
                    </div>
                  );
                },
              },
            ]}
            pagination={false}
          />
        </div>
      </CustomCard>
      {/* <CustomDrawer
        open={open}
        onClose={() => setOpen(false)}
        title="Details"
        width={500}
      >
        <CaseResultDetailDrawerContent />
      </CustomDrawer> */}
    </div>
  );
};

export default SingleCaseAllRecords;
